<template>
  <div class="text-panel-box">
    <div class="text-panel-left-box">
      <div class="left-text-box">
        <el-col :span="20">
          <el-input
            v-model="text"
            type="textarea"
            :rows="24"
            clearable
            :placeholder="placeholderText"
          ></el-input>
        </el-col>
      </div>
      <el-button
        type="primary"
        style="position: absolute; bottom: 5%; left: 22%"
        @click="textParsingOpt"
        >文本解析</el-button
      >
    </div>
    <div class="text-panel-middle-box">
      <!-- <div style="text-align: center; margin-bottom: 30px">
        <img
          src="@src/common/assets/images/arrows_left.png"
          style="cursor: pointer"
          alt=""
          @click="changeTextOpt"
        />
      </div> -->
      <div style="text-align: center">
        <img
          src="@src/common/assets/images/arrows_right.png"
          alt=""
          @click="changeFormOpt"
        />
      </div>
    </div>
    <div class="text-panel-right-box">
      <el-form
        style="height: 85%; position: absolute; width: 45%; margin-top: 5%"
        :inline="true"
        :model="textInfo"
        :rules="rules"
        ref="refForm"
        label-width="130px"
        label-position="right"
        label-suffix=" ："
      >
        <el-scrollbar style="height: 100%">
          <div>
            <el-col :span="24">
              <el-form-item label="柜号" prop="cabinetNumberPage">
                <el-input
                  v-model="textInfo.cabinetNumberPage"
                  clearable
                  placeholder="请输入柜号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="作业类型" prop="operateType">
                <el-radio-group v-model="textInfo.operateType">
                  <el-radio :label="1">装货</el-radio>
                  <el-radio :label="2">卸货</el-radio>
                  <el-radio :label="3">过车</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="textInfo.operateType == 3">
              <el-form-item label="操作类型" prop="passType">
                <el-radio-group v-model="textInfo.passType">
                  <el-radio :label="1">倒入</el-radio>
                  <el-radio :label="2">倒出</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="客户名称">
                <el-input
                  v-model="textInfo.custom"
                  clearable
                  placeholder="请输入客户名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="司机姓名">
                <el-input
                  v-model="textInfo.driverName"
                  clearable
                  placeholder="请输入司机姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="电话">
                <el-input
                  v-model="textInfo.phone"
                  clearable
                  placeholder="请输入电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="前车车牌">
                <el-input
                  v-model="textInfo.frontPlate"
                  clearable
                  placeholder="请输入前车车牌"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="货品名称">
                <el-input
                  clearable
                  v-model="textInfo.waresName"
                  placeholder="请输入货品名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="数量">
                <el-input
                  clearable
                  v-model="textInfo.waresCount"
                  placeholder="请输入数量"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="重量">
                <el-input
                  clearable
                  v-model="textInfo.waresWeight"
                  placeholder="请输入重量"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="预约到达时间" prop="estimatedArrivalTime">
                <el-date-picker
                  clearable
                  v-model="textInfo.estimatedArrivalTime"
                  type="date"
                  placeholder="请选择预约到达时间"
                  style="width: 100%"
                  format="yyyy/MM/dd"
                  value-format="yyyy/MM/dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </div>
        </el-scrollbar>
      </el-form>
      <el-button
        type="primary"
        style="position: absolute; bottom: 5%; right: 22%"
        @click="saveFormOpt"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { api } from "../api";
import utils from "@src/common/utils";

const resetForm = () => {
  return {
    appointmentId: null,
    appointmentUuid: null /**车辆预约UUID*/,
    driverId: null /**司机ID*/,
    driverName: "" /**姓名*/,
    phone: "" /**手机号码*/,
    vehicleId: null /**车辆ID*/,
    frontPlate: "", // 前车车牌
    trailerPlate: "", //后车车牌
    appointmentType: null /**进出类型：1：进门，2：出门*/,
    operateType: null /**操作类型：1：装货、2：卸货、3：过车*/,
    passType: null /**过车类型：1：倒入，2：倒出*/,
    appointmentPark: "" /**预约园区ID*/,
    estimatedArrivalTime: "" /**预计到达时间*/,
    custom: "" /**客户*/,
    cabinetNumber: "" /**货柜数量*/,
    cabinetNumberPage: "", // 页面展示的柜号
    waresName: "", // 货物名称
    waresCount: "", // 货品数量
    waresWeight: "", // 货品重量
    serialNumber: "" /**流水号*/,
    appointmentStatus: null, // 状态
    picture: "" /**司机照片*/,
    frontLicensePlatePicture: "" /**前车牌照片*/,
    trailerLicensePlatePicture: "" /**挂车牌照片*/,
    carPicture: "" /**车身照片*/,
    companyCode: "" /**公司编号*/,
    specialProductFlag: "" /**是否特殊商品 1：是；0：否*/,
    isPauseWork: "" /**是否暂停作业 1：是；0：否*/,
    dataSource: "" /**数据来源 1：客服录入；0：司机预约*/,
    refAppointmentUuid: "" /**倒柜车辆预约UUID*/,
    creator: "" /**创建人(登录账号)*/,
    createTime: "" /** 创建时间 */,
    modifier: "", // 修改人(登录账号)
    modifyTime: "" /** 修改时间 */,
    checkInTime: "" /** 修改时间 */,

    vehicleCabinets: [],
  };
};
export default {
  props: {},
  data() {
    const validatePhone = (rule, value, callback) => {
      var reg = new RegExp("^1[3456789]\\d{9}$");
      if (!reg.test(value)) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    const validateNumber = (rule, value, callback) => {
      var reg = new RegExp("^[0-9]+$");
      if (!reg.test(value)) {
        callback(new Error("格式不正确"));
      } else {
        callback();
      }
    };
    return {
      text: "",
      textInfo: resetForm(),
      rules: {
        cabinetNumberPage: [
          {
            required: true,
            message: "请输入柜号",
            trigger: ["blur", "change"],
          },
        ],
        operateType: [
          {
            required: true,
            message: "请选择作业类型",
            trigger: ["blur", "change"],
          },
        ],
        passType: [
          {
            required: true,
            message: "请选择操作类型",
            trigger: ["blur", "change"],
          },
        ],
        estimatedArrivalTime: [
          {
            required: true,
            message: "请选择预约到达时间",
            trigger: ["blur", "change"],
          },
        ],
      },
      placeholderText: `出库日期： 3.29
冷库：天津优冷智联冷库 
柜号：APRU6113612
品名：冷冻去骨牛前部位肉90vl(抢掠)
件数：100
厂号：SIF4507
原产国：巴西
-----------------------------
是否押车：（押车） 
其他要求：（抄码，散出） 
司机信息： 津RRA600
13730572799
港口：天津（中国`,
    };
  },
  mounted() {
    this.parkType = [utils.Cache.get("CACHE_USER_INFO").parkInfoTree];
    // 获取系统当前时间
    console.log("-系统时间:-", new Date());
  },
  methods: {
    handleRestForm() {
      this.text = "";
      this.textInfo = resetForm();
      this.$nextTick(() => {
        this.$refs["refForm"].clearValidate();
      });
    },
    // 文本解析操作
    textParsingOpt() {
      console.log("文本解析操作");
      // this.handleRestForm();
      if (this.text == "") {
        return this.$message.warning("请输入要解析得文本内容!");
      }
      console.log("-父组件:-");
      this.$fetch(api.text.textParsing, { textParsing: this.text }).then(
        (res) => {
          if (res && res.success) {
            this.$message({
              message: "解析成功",
              type: "success",
              duration: 1000,
            });
            console.log("-解析内容:-", res.returnObj);
            this.textInfo = Object.assign(this.textInfo, res.returnObj);
            if (this.textInfo.vehicleCabinets.length > 0) {
              let cabinetArr = this.textInfo.vehicleCabinets;
              let cabinetNumberArr = [];
              let waresNameArr = [];
              let waresCountArr = [];
              let waresWeightArr = [];
              cabinetArr.forEach((item) => {
                cabinetNumberArr.push(item.cabinetNumber);
                waresNameArr.push(item.waresName);
                waresCountArr.push(item.waresCount);
                waresWeightArr.push(item.waresWeight);
              });
              this.textInfo.cabinetNumberPage = cabinetNumberArr.join(","); // 柜号
              this.textInfo.waresName = waresNameArr.join(","); // 货物名称
              this.textInfo.waresCount = waresCountArr.join(","); // 货品数量
              this.textInfo.waresWeight = waresWeightArr.join(","); // 货品重量
            } else {
              this.textInfo.cabinetNumberPage = ""; // 柜号
              this.textInfo.waresName = ""; // 货物名称
              this.textInfo.waresCount = ""; // 货品数量
            }
            this.textInfo.estimatedArrivalTime =
              this.textInfo.estimatedArrivalTime.replaceAll("-", "/");
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 1000,
            });
          }
        }
      );
    },
    // 转文本操作
    changeTextOpt() {
      console.log("转文本操作");
    },
    // 转表单操作
    changeFormOpt() {
      console.log("转表单操作");
    },
    // 保存form表单操作
    saveFormOpt() {
      this.$refs.refForm.validate((res) => {
        if (res) {
          let params = { ...this.textInfo };
          // 调用文本录入接口 拼接请求参数 cabinetNumber, waresCount, waresName, waresWeight
          params.vehicleCabinets = [
            {
              cabinetNumber: this.textInfo.cabinetNumberPage,
              waresCount: this.textInfo.waresCount,
              waresName: this.textInfo.waresName,
              waresWeight: this.textInfo.waresWeight,
            },
          ];
          this.$fetch(api.text.addEnter, params).then((res) => {
            if (res && res.success) {
              console.log("-解析内容:-", res.returnObj);
              this.$message({
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.$emit("save-text-info", params);
              // 关闭弹窗
              this.$parent.$parent.handleCloseTextPanel();
              this.handleRestForm();
            } else {
              this.$message({
                message: res.prompt,
                type: "error",
                duration: 2000,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-panel-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  .text-panel-left-box {
    width: 47%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .left-text-box {
      width: 100%;
      height: 85%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .text-panel-middle-box {
    width: 5%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .text-panel-right-box {
    width: 48%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-form-item {
      width: 100%;
      display: flex;
      :deep .el-form-item__content {
        width: calc(100% - 125px);
      }
      .el-input__inner {
        width: 100%;
      }
    }
  }
}
</style>
